import ReactMarkdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";
import { cn } from "../lib/cn";

const components: Components = {
  a: ({ href, children, title }) => (
    <a href={href} title={title} {...(href && !href.startsWith("#") ? { target: "_blank", rel: "noopener noreferrer" } : {})}>
      {children}
    </a>
  ),
  table: ({ children }) => <div className="overflow-x-auto"><table>{children}</table></div>,
};

/** Model output is untrusted: keep React Markdown's HTML escaping and safe URL transformation. */
export function Markdown({ children, className }: { children: string; className?: string }) {
  return (
    <div className={cn("nd-markdown min-w-0 text-body text-fg-body", className)}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>{children}</ReactMarkdown>
    </div>
  );
}
